var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDangerArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26911",
    "data-name": "Group 26911",
    transform: "translate(-13580 8392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6257",
    "data-name": "Rectangle 6257",
    transform: "translate(13580 -8384) rotate(-90)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.001
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_73",
    "data-name": "Union 73",
    d: "M3.23,4.689.317,1.827a1.053,1.053,0,0,1,0-1.506A1.128,1.128,0,0,1,1.112,0a1.128,1.128,0,0,1,.795.321L4,2.376,6.089.321a1.145,1.145,0,0,1,1.59,0,1.053,1.053,0,0,1,0,1.506L4.766,4.689a1.1,1.1,0,0,1-1.535,0Z",
    transform: "translate(13581.5 -8384.004) rotate(-90)",
    fill: "#f02833"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerArrow);
export default __webpack_public_path__ + "static/media/danger-arrow.94751fcab19cd81f2481bd1d9216d0bc.svg";
export { ForwardRef as ReactComponent };